<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">A heartfelt thanks to those whose advice and expertise proved invaluable while I was writing this book: Michael Barrett, Jane Dystel, David Goldner, Ruth Harris, Ann LaFarge, Bob Patent, and Edwin Shmerler.</p>
<p>Special gratitude to my husband, Michael, and to my family and friends, who cheered me on and made me feel that I wasn’t in over my head.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?560e6f48